import { render, staticRenderFns } from "./ChatAnswerReportPanel.vue?vue&type=template&id=3f587d89&scoped=true&"
import script from "./ChatAnswerReportPanel.vue?vue&type=script&lang=ts&"
export * from "./ChatAnswerReportPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f587d89",
  null
  
)

export default component.exports